import { useState, useEffect } from 'react';
import { Button } from 'react-bootstrap';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';

import { FlexGrid, FlexGridCellTemplate, FlexGridColumn } from '@grapecity/wijmo.react.grid';
import { FlexGridFilter } from '@grapecity/wijmo.react.grid.filter';
import { useRef } from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import { ClientType } from 'constants/constants';

// 類似顧客確認モーダル画面
function SimilarModal(props) {
  // グリッド
  const flexGrid = useRef();

  const [show, setShow] = useState();

  //保存かどうか
  const [isSave, setIsSave] = useState(false);

  useEffect(() => {
    if (props.params.client) {
      setIsSave(props.params.isSave);
      setShow(true);
    }
  }, [props.params]);

  // キャンセルボタンクリック
  const handelOnClickCancel = () => {
    setShow(false);
  };

  // OKボタンクリック
  const handelOnClickOk = () => {
    props.params.okCallBack();
    setShow(false);
  };

  return (
    <Dialog fullWidth={true} maxWidth={'lg'} open={show}>
      <DialogTitle className="confirm-modal-header p-2">確認</DialogTitle>
      <DialogContent>
        <div className="mb-3 mt-3">
          類似した顧客情報が既に登録されています。
          {isSave && '別の顧客として登録してよろしいですか？'}
        </div>
        <Card className="m-0">
          <Row>
            <Col>
              <div className="table-scroll" style={{ height: 'calc(100vh - 370px)' }}>
                <FlexGrid
                  ref={flexGrid}
                  isReadOnly={true}
                  itemsSource={props.params.client}
                  selectionMode={'Row'}
                  headersVisibility={'Column'}
                  style={{ height: 'auto' }}
                >
                  <FlexGridFilter />
                  <FlexGridColumn
                    binding="NAME_1"
                    header={props.params.clientType == ClientType.USER ? '顧客名１' : '請求先名'}
                    width={140}
                  ></FlexGridColumn>
                  <FlexGridColumn binding="NAME_KANA_1" header="顧客名１カナ"></FlexGridColumn>
                  <FlexGridColumn binding="CITY" header="市"></FlexGridColumn>
                  <FlexGridColumn binding="TOWN" header="町村"></FlexGridColumn>
                  <FlexGridColumn binding="ADDRESS" header="番地"></FlexGridColumn>
                  <FlexGridColumn
                    binding="FIRST_INQUIRY_DAY"
                    header="初回問合せ日"
                  ></FlexGridColumn>
                  <FlexGridColumn binding="POST_CODE" header="郵便番号" width={80}></FlexGridColumn>
                  <FlexGridColumn binding="PREF" header="都道府県"></FlexGridColumn>
                  <FlexGridColumn binding="TEL1" header="電話番号１" width={120}>
                    <FlexGridCellTemplate
                      cellType="Cell"
                      template={(cell) => (
                        <span>
                          {cell.item.TEL1}{' '}
                          {cell.item.TEL_RELATION_1 ? `(${cell.item.TEL_RELATION_1})` : ''}
                        </span>
                      )}
                    />
                  </FlexGridColumn>
                  <FlexGridColumn
                    binding="MAIL"
                    header="メールアドレス"
                    width={150}
                  ></FlexGridColumn>
                  <FlexGridColumn binding="BIKO" header="備考"></FlexGridColumn>
                </FlexGrid>
              </div>
            </Col>
          </Row>
        </Card>
      </DialogContent>
      <DialogActions className="p-3" style={{ justifyContent: 'space-between' }}>
        <Button variant="secondary" className="footer-button" onClick={handelOnClickCancel}>
          {isSave ? '戻る' : '閉じる'}
        </Button>
        {isSave && (
          <Button
            variant="primary"
            className="btn-fill footer-button"
            onClick={() => {
              handelOnClickOk();
            }}
          >
            OK
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
}

export default SimilarModal;
